export default {
  // le decimos a vuex que haremos uso de los espacios de nombre, para llarmalo por utils
  namespaced: true,

  // definimos las acciones, funciones que hacen uso de nuestros estados
  actions: {
    /**
     * @return {Promise}
     */
    async buildPermissionsForTree({ dispatch }, data) {
      let specific = JSON.parse(JSON.stringify(data));
      return new Promise((resolve, reject) => {
        try {
          let response = {};
          specific.map((item) => {
            item.disabled = true;
            let i = item.parent + '_' + item.module;

            if (response[i] == undefined) {
              response[i] = [];
            }

            response[i].push(item);
          });

          resolve(response);
        } catch (error) {
          reject(false);
        }
      });
    },

    /**
     * @return {Promise}
     */
    async validationInputsRequired({ dispatch }, reference) {
      return new Promise((resolve, reject) => {
        let elementsArray = document.getElementsByClassName(
          'required' + reference
        );
        for (let key of elementsArray) {
          let inputsArray = key.getElementsByTagName('input');
          for (let index of inputsArray) {
            if (index.value.length == 0) {
              index.focus();
              index.classList.add('custom-has-error');
              dispatch('removeHasError', index);
              reject(false);
            }
          }
        }
        resolve(true);
      });
    },

    async removeHasError({ dispatch }, index) {
      // if (index.classList.contains('el-input__inner'))
      setTimeout(() => {
        index.classList.remove('custom-has-error');
      }, 3000);
      return true;
    },
  },
};
